export function createDoctorCard(block, parent) {
    const blockName = block.data_block_name;
    const doctorNumber = blockName.replace('doctor-', '');

    const card = document.createElement('div');
    card.className = 'doctor-card carousel-item';
    card.setAttribute('data-block-name', blockName);

    if (block.id && block.id !== 'undefined') {
        card.setAttribute('data-block-id', block.id);
    }

    if (block.order !== undefined && block.order !== null) {
        card.setAttribute('data-order', String(block.order));
    } else {
        card.setAttribute('data-order', '0');
    }

    card.style.position = 'relative';

    card.innerHTML = `
        <div class="doctor-image">
            <img src="" alt="" data-content="${blockName}-image" data-type="image">
        </div>
        <h3 class="doctor-name" data-content="${blockName}-name"></h3>
        <p class="doctor-description" data-content="${blockName}-description" data-type="textarea"></p>
    `;

    parent.appendChild(card);
    return card;
}

export const doctorCardProps = {
    name: 'doctor-card',
    title: 'Карточка доктора',
    description: 'Карточка с фото, именем и описанием доктора',
    allowedParents: ['doctors-block'],
    contentFields: [
        {name: 'name', type: 'text', label: 'Имя доктора'},
        {name: 'description', type: 'textarea', label: 'Описание'},
        {name: 'image', type: 'image', label: 'Фото доктора'}
    ],
    renderPreview: (data) => {
        return `
            <div class="block-preview doctor-card-preview">
                <div class="image-placeholder"></div>
                <h4>${data.name || 'Имя доктора'}</h4>
                <p>${data.description || 'Описание доктора...'}</p>
            </div>
        `;
    }
};